import { useCallback, useEffect } from "react";

import {
  getPaymentMethodDetails,
  isEasyPayEligible,
  isEasyPayEnrolled,
  scrollToTop,
  trackEvent,
} from "utils";

export const useCurrentPaymentMethod = (userBilling, userDetails) => {
  const enrolledInEasyPay = isEasyPayEnrolled(userBilling);

  const eligibleForEasyPayUpdate =
    isEasyPayEligible(userBilling, userDetails) || enrolledInEasyPay;

  const { paymentMethodSummaryLabel, easypayMethod, paymentFrequency } =
    getPaymentMethodDetails(
      userBilling?.accounting.paymentPlan.planType.toLowerCase(),
    ) ?? {};

  const trackEasyPayEvent = useCallback(
    (eventName, optionalProperties = {}) =>
      trackEvent(eventName, {
        paymentMethod: paymentMethodSummaryLabel,
        easypayMethod,
        paymentFrequency,
        ...optionalProperties,
      }),
    [easypayMethod, paymentFrequency, paymentMethodSummaryLabel],
  );

  useEffect(() => {
    scrollToTop();
    trackEasyPayEvent("EasyPay Edit Form Loaded");
  }, [trackEasyPayEvent]);

  return { eligibleForEasyPayUpdate, trackEasyPayEvent };
};
